import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import Portfolio from "./pages/Portfolio";
import Careers from "./pages/Careers";
import ContactPage from "./pages/ContactPage";
import JobApplicationPage from "./pages/ApplicationPage";
import ScrollToTop from "./components/ScrollToTop";
import FAQs from './pages/FAQPage';
import Privacy from './pages/PrivacyPage';
import Terms from './pages/TermPage';
import PrivacyPolicy from "./pages/PrivacyPolicy";

const App = () => {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:id" element={<ServiceDetailPage />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/apply/:position" element={<JobApplicationPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        </Routes>

        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
